module.exports = __webpack_public_path__ + "img/2.627cc4ff.png";